
import * as offer from './offer';
import {getUrlParam} from '../pages/util/common'
import '@ali/lib-mtop';
window.lib.mtop.config.prefix = 'h5api';
window.lib.mtop.config.subDomain = getUrlParam('debugMode') == 1 ? 'wapa' : 'm';
window.lib.mtop.config.mainDomain = '1688.com';

if (window.location.href.includes("pre-p4psearch.1688.com")) {
  window.lib.mtop.config.subDomain = 'wapa';
}

export const mtop = (api, data, ...options) => {
  return window.lib.mtop.request({
    api, // 必须
    v: '1.0',  // 必须
    data,
    ecode: 0,   // 必须（注意2）
    type: 'GET',   // 非必须。请求类型（GET/POST），默认是GET
    dataType: 'jsonp', // 非必须。数据类型（jsonp/originaljsonp/json），默认jsonp
    timeout: 20000, // 非必须。接口超时设置，默认为20000ms
    ...options,
  }, (res) => {
    goldlog.record(
      "/ifission.ifission.autoWW",
      "CLK",
      `code=${res.data? res.data.code : ''}&msg=${res.data? res.data.msg : ''}`,
      "GET"
    );
  });
};

export const sendWW = (eurl, itemId, bizId) => {
  mtop('mtop.hamlet.engine.gateway', {
    apiEngineType: '2',
    api: 'cplEnquiry',
    params: JSON.stringify({
      sk: "d816e70d380f8694a49f2d4aa2aae51d",
      ak: "mtop",
      paramMap: {
        bizId,
        pushChannelType: "WANG_WANG",
        pushTriggerType: "MANUAL",
        items:[
          {
            "eurl": eurl,
            "itemType": "AD",
            "itemId": itemId
          }
        ]
      }
    })
  })
}

export const cplRecallRank = async (offerId, rankName, ptid, cosite) => {
  let data = null;
  await window.lib.mtop.request({
    api: 'mtop.hamlet.engine.gateway',
    v: '1.0',
    data: {
      apiEngineType: '2',
      api: 'cplRecall',
      params: JSON.stringify({
        sk: "d816e70d380f8694a49f2d4aa2aae51d",
        ak: "mtop",
        paramMap: {
          bizId: "lp_pc_rank",
          offerId,
          count: "8",
          offset: "0",
          rankName,
          ptid,
          cosite
        }
      })
    }
  }, (res) => {
    data = res.data;
  });
  return data;
}

export const cplEnquiry = async ({offerId, mobilePhone, nlq, pushChannelType, items}) => {
  let data = [];
  await window.lib.mtop.request({
    api: 'mtop.hamlet.engine.gateway',
    v: '1.0',
    type: "POST",
    data: {
      apiEngineType: '2',
      api: 'cplEnquiry',
      params: JSON.stringify({
        sk: "d816e70d380f8694a49f2d4aa2aae51d",
        ak: "mtop",
        paramMap: {
          bizId: "lp_pc_rank",
          pushTriggerType: "MANUAL",
          authorized: true,
          pushChannelType,
          items,
          mobilePhone,
          offerId,
          nlq,
        }
      })
    }
  }, (res) => {
    data = res.data;
  });
  return data;
}

export const getLogin = async () => {
  let data = null;
  await window.lib.mtop.request({
    api: 'mtop.hamlet.engine.gateway',
    v: '1.0',
    type: "POST",
    data: {
      apiEngineType: '2',
      api: 'isLogin',
      params: JSON.stringify({
        sk: "d816e70d380f8694a49f2d4aa2aae51d",
        ak: "mtop",
      })
    }
  }, (res) => {
    data = res.data && res.data.data;
  });
  return data;
}

export default {
    ...offer,
};

